import React from "react";
import UpdateReview from "../../components/Pages/Reviews/Update/Update";

const ReviewUpdate = () => {
  return (
    <div>
      <UpdateReview />
    </div>
  );
};

export default ReviewUpdate;
